import Mortgage from './components/mortgage/mortgage.vue'

Vue.component('mortgage', Mortgage);


// WEBPACK FOOTER //
// ./src/main.js